(function (Translator) {
    // es
    Translator.add("theme.dropzone.drop-files-here", "Arrastre los archivos aqu\u00ed para subirlos", "DropZone", "es");
    Translator.add("theme.dropzone.max-file-size", "El tama\u00f1o m\u00e1ximo del archivo es de %maxFileSize%", "DropZone", "es");
    Translator.add("theme.dropzone.max-number-of-files", "El n\u00famero m\u00e1ximo de archivos es %maxNumberOfFiles%", "DropZone", "es");
    Translator.add("theme.dropzone.not_allowed_file_mime_type", "Este archivo no permite el tipo MIME", "DropZone", "es");
    Translator.add("theme.dropzone.or", "o", "DropZone", "es");
    Translator.add("theme.dropzone.select_file", "Seleccione un archivo", "DropZone", "es");
    Translator.add("theme.dropzone.selected_files", "Archivos v\u00e1lidos importados", "DropZone", "es");
    Translator.add("theme.dropzone.selected_files_with_errors", "Archivos inv\u00e1lidos", "DropZone", "es");
    Translator.add("theme.dropzone.selected_transfer_serial_number_in_file", "Transferir un n\u00famero a un archivo", "DropZone", "es");
    Translator.add("theme.dropzone.too_big_file", "Este archivo es demasiado grande para importarlo", "DropZone", "es");
})(Translator);
